import $chats from 'stores/chats'
import $global from 'stores/global'
import $profile from 'stores/profile'
import {computed} from 'vue'

export const ITEMS = computed(() => {
  const nav_items = []
  if ($global.fileUploadEnabled) {
    nav_items.push({
      icon: 'file-04',
      title: 'Files',
      is_link: true,
      route: '/files'
    })
  }

  nav_items.push({
    icon: 'activity',
    title: 'Pulse',
    route: '/pulse',
    query: {tab: 'feed'},
    is_link: true,
    allow_mobile: true,
  })
  nav_items.push({
    icon: 'bot',
    title: 'Trackers',
    route: '/pulse',
    query: {tab: 'tracker'},
    is_link: true,
    allow_mobile: false,
  })


  if ($profile.is_admin) {
    nav_items.push({
      icon: 'file-06',
      title: 'Shared Files',
      is_link: true,
      route: '/sh-files',
      admin_only: true,
    })

    nav_items.push({
      icon: 'building-08',
      title: 'Shared Companies',
      is_link: true,
      route: '/sh-companies',
      admin_only: true,
    })

    nav_items.push({
      icon: 'users',
      title: 'Shared Contacts',
      is_link: true,
      route: '/sh-contacts',
      admin_only: true,
    })

    nav_items.push({
      icon: 'tag',
      title: 'Shared Topics',
      is_link: true,
      route: '/sh-topics',
      admin_only: true,
    })
  }

  if ($profile.is_admin || $profile.is_tenant_manager) {
    nav_items.push({
      icon: 'user-03',
      title: 'Your Tenant',
      is_link: true,
      route: '/tenant',
      admin_only: true,
      tenant_manager_only: true,
    })
  }

  if ($profile.is_admin) {
    nav_items.push({
      icon: 'user-03',
      title: 'Tenants',
      is_link: true,
      route: '/tenants',
      admin_only: true,
    })

    if (DEV_MODE === 'true') {
      nav_items.push({
        icon: 'puzzle-piece-02',
        title: 'Playground',
        is_link: true,
        route: '/playground',
        admin_only: true,
      })
    }
  }

  if ($chats.chats.length) {
    const grouped_data = groupChatsByDateRange($chats.chats)
    nav_items.push({
      icon: 'message-text-circle-02',
      title: 'Chat',
      matched_routes: ['/chat', '/new-chat'],
      route: '/new-chat',
      type: 'chats',
      is_link: true,
      opened: !!grouped_data.length,
      children: [
        ...grouped_data.map(([title, stores]) => ({
          title,
          children: stores.map(store => (
            {
              store,
              matched_routes: ['/chat'],
              query: {id: store.id},
              route: `/chat?id=${store.id}`,
              is_link: true
            }
          )),
        }))
      ],
      allow_mobile: true
    })
  }
  else {
    nav_items.push({
      icon: 'message-text-circle-02',
      title: 'Chat',
      route: '/new-chat',
      is_link: true,
      allow_mobile: true
    })
  }
  return nav_items
}
)

function groupChatsByDateRange(stores) {
  const MONTH_IN_YEAR = 12
  const today = new Date()
  today.setHours(0, 0, 0, 0)

  const rest_by_days = {}
  const rest_by_month = {}
  const rest_by_year = {}

  const addToDays = (store, key) => {
    rest_by_days[key] = rest_by_days[key] || []
    rest_by_days[key].push(store)
  }

  const addToRestByMonth = (store, date) => {
    const month_year_key = date.toLocaleString('default', {month: 'long'})
    rest_by_month[month_year_key] = rest_by_month[month_year_key] || []
    rest_by_month[month_year_key].push(store)
  }

  const addToRestByYear = (store, diff_years) => {
    const year_key = `${diff_years} year${diff_years > 1 ? 's' : ''} ago`
    rest_by_year[year_key] = rest_by_year[year_key] || []
    rest_by_year[year_key].push(store)
  }

  stores.forEach(store => {
    const date = new Date(store.created_at)
    const diff_time = Math.abs(today - date)
    const diff_days = Math.ceil(diff_time / (1000 * 60 * 60 * 24))

    if (diff_days <= 1)
      addToDays(store, 'Recent')
    else if (diff_days <= 7)
      addToDays(store, 'Last 7 days')
    else if (diff_days <= 14)
      addToDays(store, 'Last 14 days')
    else {
      const diffMonths = (today.getFullYear() - date.getFullYear()) * MONTH_IN_YEAR + today.getMonth() - date.getMonth()
      if (diffMonths < MONTH_IN_YEAR)
        addToRestByMonth(store, date)
      else
        addToRestByYear(store, Math.floor(diffMonths / MONTH_IN_YEAR))
    }
  })

  // Sort groups by date
  const groups = Object.entries({...rest_by_days, ...rest_by_month, ...rest_by_year})
    .sort(([, valuesA], [, valuesB]) => new Date(valuesB[0].created_at) - new Date(valuesA[0].created_at))

  return groups
}
